<div
  class="blog-card"
  inViewport
  (elementIsVisible)="loadMoreIfLastIndex()"
  [lastElement]="lastElement"
>
  <img [src]="blog.img" [alt]="blog.img" height="100" width="100" />

  <h4>{{ blog.title }}</h4>
  <p>{{ blog.description }}</p>
  <span>{{ blog.createAt | date : "MMMM d, y" }} • {{ readTime }} minutes</span>
  <app-action-menu
    [isOpen]="index === menuOpenIndex"
    (delete)="onDeleteBlog()"
    (edit)="handleEditBlog(blog.id)"
    (outsideClick)="closeAllMenu()"
    (open)="openMenu()"
  ></app-action-menu>
</div>
